export const hideCookieBannerURLs = [
  '/privacy-policy',
  '/earning-vault-terms-and-conditions',
  '/terms-and-conditions',
  '/cookie-policy',
  '/cryptocurrency-offering-terms-and-conditions',
];
